import React, { Component } from 'react';
import { Tooltip, Modal } from '../../../UiKit';
import { TagsDetails } from '../../popups';
import { sendEventToJumbo } from '../../../helpers/analytics';

export default class Tags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTagsPopup: false,
      uniqueTags: null,
    };
  }

  showTagsDetails = () => {
    sendEventToJumbo('tags_pop_show_event');
    this.setState({
      showTagsPopup: true,
    });
  };

  closePopup = () => {
    sendEventToJumbo('tags_pop_close_event');
    this.setState({
      showTagsPopup: false,
    });
  };

  getUniqueTags = () => {
    const { tags } = this.props;
    if (!tags) return null;
    const uniqueTags = Array.from(new Set(tags.map((a) => a.reason_id))).map(
      (reason_id) => {
        return tags.find((a) => a.reason_id === reason_id);
      },
    );
    return uniqueTags;
  };

  getTagTemplate = (tag, tagName, index) => {
    return (
      <>
        {tagName && (
          <span className='tw-flex tw-h-full' onClick={this.showTagsDetails}>
            <Tooltip
              position='bottom'
              border={false}
              title={
                <div
                  className={`tw-text-200 tw-flex tw-items-center tw-h-full tw-transition-all tw-ease-in-out tw-duration-300 ${
                    index === 2
                      ? 'hover:tw-bg-green-100/50'
                      : 'hover:tw-bg-grey-100/60'
                  } tw-px-4 tw-rounded-lg tw-font-medium ${
                    tag.type === 'SYSTEM'
                      ? 'tw-text-[#0366D6]'
                      : 'tw-text-[#828282]'
                  } ${tagName.includes('+') ? 'tw-text-green-700' : ''}`}
                >
                  {tagName}
                </div>
              }
              label={index === 2 ? 'See all tags' : 'Click to view details'}
            />
          </span>
        )}
      </>
    );
  };

  renderTags = () => {
    const uniqueTags = this.getUniqueTags();

    if (!uniqueTags) return null;

    const minTagsShows = uniqueTags.splice(0, 3);

    return (
      minTagsShows?.length > 0 &&
      minTagsShows.map((tag, index) => {
        let tagName = tag.title || '';

        return (
          <React.Fragment key={index}>
            {this.getTagTemplate(tag, tagName)}
            {index === 2 && uniqueTags.length
              ? this.getTagTemplate(tag, `+${uniqueTags.length} more`, 2)
              : null}
          </React.Fragment>
        );
      })
    );
  };

  render() {
    const { tags } = this.props;
    const { showTagsPopup } = this.state;

    if (!tags) return null;

    return (
      <div className='tw-h-full tw-flex'>
        {this.renderTags()}
        {showTagsPopup && (
          <Modal
            isVisible={showTagsPopup}
            type='large'
            title='Tags Log'
            handleClose={this.closePopup.bind(this)}
            component={<TagsDetails tags={tags} />}
          />
        )}
      </div>
    );
  }
}
